// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"498":"07f4ed47","945":"07f4ed47"}[chunkId] + ".chunk.css";
};